<template>
	<br>
</template>
<script>
import { getSearchResultsApi } from '../../../../../shared/utils/api/data-subject-search.js'
import { DATA_SUBJECT, DATA_SUBJECT_SEARCH } from '../../../router/route-names.js'
import { csPortalBrandSelector, userBrandIdsFilter, UNIVERSAL_BRAND, changeSelectedBrand } from '../../../../../shared/state/brands.js'
import { showSnackbar } from '../../../../../shared/state/snackbar.js'
import { VALID_SEARCH_FIELDS } from '../../../../../shared/lib/magic-link-valid-fields.js'

export default {
	name: 'single-data-subject-search',
	props: {
		searchField: String,
		searchValue: String,
		brandId: String
	},
	setup () {
		return {
			csPortalBrandSelector,
			userBrandIdsFilter,
			showSnackbar,
			changeSelectedBrand
		}
	},
	data () {
		return {
			searchResults: []
		}
	},
	created () {
		this.trySearch()
	},
	methods: {
		async trySearch () {
			const searchBrandId = Number.parseInt(this.brandId, 10)
			if (!this.searchField || !this.searchValue || Number.isNaN(searchBrandId)) {
				return this.goToSearchPage()
			}
			const field = this.searchField.toLowerCase()
			if (!VALID_SEARCH_FIELDS.has(field)) {
				showSnackbar({ text: `Invalid search field: ${this.searchField}`, color: 'red' })
				return this.goToSearchPage()
			}

			// Force brand selector evaluation (kept from original logic)
			// eslint-disable-next-line no-unused-vars
			const _ = csPortalBrandSelector.value
			if (searchBrandId !== UNIVERSAL_BRAND && !userBrandIdsFilter.value.includes(searchBrandId) && !userBrandIdsFilter.value.includes(UNIVERSAL_BRAND)) {
				return this.goToSearchPage()
			}
			changeSelectedBrand(searchBrandId)
			const params = { [field]: this.searchValue }
			const displayDataSubjectsWithNoPreferences = true

			try {
				const { data = [] } = await getSearchResultsApi(
					params,
					searchBrandId,
					displayDataSubjectsWithNoPreferences,
					true
				)
				this.searchResults = data

				if (data.length === 1) {
					const row = data[0]
					const allIds = data
						.filter(({ groupId, syrenisId }) =>
							groupId !== null ? groupId === row.groupId : syrenisId === row.syrenisId
						)
						.map(({ syrenisId }) => syrenisId)
						.join(',')

					return this.$router.push({
						name: DATA_SUBJECT,
						query: {
							id: row.syrenisId,
							allIds,
							brandId: searchBrandId
						}
					})
				}
				this.goToSearchPage()
			} catch {
				this.goToSearchPage()
			}
		},
		goToSearchPage () {
			this.$router.replace({ name: DATA_SUBJECT_SEARCH })
		}
	}
}
</script>
